import React from "react";
import MomentumAnalysisPage from "./MomentumAnalysisPage";
import {
  getUsMomentumAnalysis,
  refreshUsMomentumAnalysis,
  updateUsMomentumAnalysisSettings,
} from "../lib/api";


const US_CONFIG = {
  market: "US",
  get: getUsMomentumAnalysis,
  refresh: refreshUsMomentumAnalysis,
  updateSettings: updateUsMomentumAnalysisSettings,
};


export default function UsMomentumAnalysisPage({ onStockClick }) {
  return <MomentumAnalysisPage onStockClick={onStockClick} config={US_CONFIG}/>;
}
